import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import _isArray from "lodash/isArray";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink, matchPath, useLocation } from 'react-router-dom';
import { Icon } from '../../Icon';
import Tooltip from '../../Tooltip';
import { tooltipContainer, menuItem, menuItemContent, menuItemText, tooltipContent, subMenuList, menuSubItem, menuSubSubItem, subMenusTreeContainer, subSubMenusTreeContainer, menuSubGroupHeader, menuItemRightIcon } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var isChildActive = function isChildActive(el, pathname) {
  if (matchPath(pathname, {
    path: el.url,
    exact: false,
    strict: false
  })) return true;
  if (_isArray(el.subMenus)) return el.subMenus.some(function (child) {
    return matchPath(pathname, {
      path: child.url,
      exact: false,
      strict: false
    });
  });
  return false;
};

export var MenuItem = function MenuItem(_ref) {
  var label = _ref.label,
      icon = _ref.icon,
      url = _ref.url,
      iconProps = _ref.iconProps,
      _ref$subMenus = _ref.subMenus,
      subMenus = _ref$subMenus === void 0 ? [] : _ref$subMenus,
      isOpen = _ref.isOpen,
      isMobile = _ref.isMobile;
  var hasSubMenus = _isArray(subMenus) && !!subMenus.length;
  var location = useLocation();
  var isSubMenuActive = hasSubMenus && subMenus.some(function (el) {
    return isChildActive(el, location.pathname);
  });

  var _useState = useState(isSubMenuActive),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1]; // Auto-expand/collapse when route changes


  useEffect(function () {
    if (hasSubMenus) setIsExpanded(isSubMenuActive);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  var mainMenuContent = ___EmotionJSX("div", {
    css: menuItemContent
  }, ___EmotionJSX(Icon, _extends({
    size: "1.6rem",
    iconName: icon
  }, iconProps)), isOpen && ___EmotionJSX("span", {
    css: menuItemText
  }, label)); // Render sub-menu items for tooltip (collapsed sidebar, desktop only)


  var renderTooltipSubMenuItems = function renderTooltipSubMenuItems(items, setIsTooltipOpen) {
    return items.map(function (el) {
      var hasChildren = _isArray(el.subMenus) && !!el.subMenus.length;

      if (hasChildren) {
        return ___EmotionJSX("div", {
          key: el.url
        }, ___EmotionJSX("div", {
          css: menuSubGroupHeader
        }, el.label), el.subMenus.map(function (child) {
          return ___EmotionJSX(NavLink, {
            key: child.url,
            to: child.url,
            css: menuSubSubItem,
            onClick: function onClick() {
              return setIsTooltipOpen(false);
            }
          }, child.label);
        }));
      }

      return ___EmotionJSX(NavLink, {
        key: el.url,
        to: el.url,
        css: menuSubItem,
        onClick: function onClick() {
          return setIsTooltipOpen(false);
        }
      }, el.label);
    });
  }; // Render sub-menu items inline (expanded sidebar — accordion)


  var renderInlineSubMenuItems = function renderInlineSubMenuItems(items) {
    return items.map(function (el) {
      var hasChildren = _isArray(el.subMenus) && !!el.subMenus.length;

      if (hasChildren) {
        var isGroupActive = el.subMenus.some(function (child) {
          return matchPath(location.pathname, {
            path: child.url,
            exact: false,
            strict: false
          });
        });
        return ___EmotionJSX("div", {
          key: el.url
        }, ___EmotionJSX(NavLink, {
          to: el.subMenus[0].url,
          className: isGroupActive ? 'active' : '',
          css: menuSubItem
        }, el.label), isGroupActive && ___EmotionJSX("section", {
          css: subSubMenusTreeContainer
        }, el.subMenus.map(function (child) {
          return ___EmotionJSX(NavLink, {
            key: child.url,
            to: child.url,
            className: matchPath(location.pathname, {
              path: child.url,
              exact: false,
              strict: false
            }) ? 'active' : '',
            css: menuSubSubItem
          }, child.label);
        })));
      }

      return ___EmotionJSX(NavLink, {
        key: el.url,
        to: el.url,
        className: matchPath(location.pathname, {
          path: el.url,
          exact: false,
          strict: false
        }) ? 'active' : '',
        css: menuSubItem
      }, el.label);
    });
  };

  if (!hasSubMenus) {
    return ___EmotionJSX(NavLink, {
      to: url,
      css: menuItem
    }, mainMenuContent);
  } // Sidebar expanded: accordion behavior (submenus expand below)


  if (isOpen) {
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
      role: "button",
      tabIndex: 0,
      css: menuItem,
      className: isSubMenuActive ? 'active' : '',
      onClick: function onClick() {
        return setIsExpanded(function (prev) {
          return !prev;
        });
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsExpanded(function (prev) {
            return !prev;
          });
        }
      }
    }, mainMenuContent, ___EmotionJSX(Icon, {
      iconName: isExpanded ? 'la la-angle-up' : 'la la-angle-down',
      color: "black",
      css: menuItemRightIcon
    })), isExpanded && ___EmotionJSX("section", {
      css: subMenusTreeContainer
    }, renderInlineSubMenuItems(subMenus)));
  } // Sidebar collapsed on desktop: tooltip flyout (never on mobile)


  if (!isMobile) {
    return ___EmotionJSX(Tooltip, {
      noArrow: true,
      content: function content(_ref2) {
        var setIsTooltipOpen = _ref2.setIsOpen;
        return ___EmotionJSX("div", {
          css: subMenuList
        }, renderTooltipSubMenuItems(subMenus, setIsTooltipOpen));
      },
      placement: "right-start",
      css: tooltipContainer,
      contentClassName: tooltipContent,
      zIndex: 1500
    }, ___EmotionJSX(NavLink, {
      to: url,
      css: menuItem
    }, mainMenuContent));
  } // Fallback (collapsed + mobile — shouldn't normally happen)


  return ___EmotionJSX(NavLink, {
    to: url,
    css: menuItem
  }, mainMenuContent);
};
MenuItem.propTypes = {
  url: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconProps: PropTypes.object,
  onSelect: PropTypes.func,
  subMenus: PropTypes.array,
  isOpen: PropTypes.bool,
  isMobile: PropTypes.bool
};